<template>
  <v-app>
    <v-app-bar app color="primary" dark clipped-left clipped-right>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/logo2.png')"
          transition="scale-transition"
          width="40"
        />
      </div>

      <v-toolbar-title class="font-weight-light ml-3" x-large
        >Extraescolares</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <span class="user" v-if="getCurrentUser() !== null">{{ getCurrentUser() }}</span>
      <v-btn class="mx-1" v-if="getCurrentUser() !== null" icon @click="logout">
        <v-icon>mdi-location-exit</v-icon>
      </v-btn>
      <v-btn class="mx-1" v-if="getCurrentUser() !== null && $store.state.view !== 'send'" icon @click="$store.state.view = 'send'; $router.replace('/send')">
        <v-icon>mdi-send</v-icon>
      </v-btn>
      <v-btn class="mx-1" v-if="(getCurrentUser() === 'carlos.sanchez@liceosorolla.es' || getCurrentUser() === 'daniel.alvarez@liceosorolla.es') && $store.state.view !== 'admin' && $store.state.view !== 'send'" icon @click="$store.state.view = 'admin'; $router.replace('/admin')">
        <v-icon>mdi-tools</v-icon>
      </v-btn>
      <v-btn class="mx-1" v-if="getCurrentUser() !== null && $store.state.view !== 'admin' && $store.state.view !== 'send'" icon @click="exportData">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn>
      <v-btn class="mx-1" v-if="getCurrentUser() !== null && $store.state.view !== 'home'" icon @click="$store.state.view = 'home'; $router.replace('/home')">
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
    </v-app-bar>
    <router-view></router-view>
  </v-app>
</template>

<script>
/* eslint-disable no-console*/
import { auth } from "./firebaseConfig.js";
import moment from 'moment';
import exportFromJSON from "export-from-json";
export default {
  name: "App",

  data: () => ({
    //
  }),
  methods: {
    exportData() {
      moment.locale("es");
      let records = [];
      this.$store.state.activities.forEach((activity)=>{
        Object.values(activity.groups).forEach((group)=>{
          Object.values(group.students).forEach((student)=>{
            let iStudent = -1;
            for(let i=0;i<this.$store.state.students.length;i++) {
              if(this.$store.state.students[i].id === student.id) {
                iStudent = i;
                break;
              }
            }
            records.push({
              Gestiona: activity.prodet ? 'Prodet' : 'Liceo Sorolla',
              Nombre: student.name,
              Sección: student.group,
              Actividad: activity.name,
              Comentario: activity.comments[student.id],
              Horario: group.schedule ? group.schedule : 'por confirmar',
              Grupo: group.name,
              Prioridad: student.priority,
              Alta: moment(new Date(student.date.seconds*1000)).format('L [-] HH:MM'),
              Estado: !activity.closed ? 'pendiente' : student.index<activity.max ? 'aceptado' : 'esperando',
              'Nombre madre': this.$store.state.students[iStudent].motherName || 'No disponible',
              'Correo madre': this.$store.state.students[iStudent].motherEmail || 'No disponible',
              'Telefono madre': this.$store.state.students[iStudent].motherCell || 'No disponible',
              'Nombre padre': this.$store.state.students[iStudent].fatherName || 'No disponible',
              'Correo padre': this.$store.state.students[iStudent].fatherEmail || 'No disponible',
              'Telefono padre': this.$store.state.students[iStudent].fatherCell || 'No disponible',
              Contacto: student.email
            })
          })
        })
      });
      exportFromJSON({
        data: records,
        fileName: this.fileName(),
        exportType: "xls",
        withBOM: true,
      });
    },
    fileName() {
      moment.locale("es");
      return (
        "Extraescolares_" +
        moment(new Date()).format("L")
      );
    },
    getCurrentUser() {
      if (auth.currentUser) {
        return auth.currentUser.email;
      } else {
        return null;
      }
    },
    logout() {
      auth.signOut().then(() => {
        this.$router.replace("/login");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.user {
  margin-right: 10px;
}
</style>
